import {useMutation} from '@apollo/react-hooks';

import type {
    IgnoreForm as IgnoreFormMutation,
    IgnoreFormVariables as IgnoreFormMutationVariables,
    ConnectedFormIgnoreInput,
} from 'nutshell-graphql-types';

import WF_FORM_STUB_FRAGMENT from '../graphql/fragments/wf-form-stub-fragment.graphql';
import IGNORE_FORM from '../graphql/mutations/ignore-form.graphql';

export function useIgnoreForm(): (arg1: ConnectedFormIgnoreInput) => Promise<any> {
    const [ignoreForm] = useMutation<IgnoreFormMutation, IgnoreFormMutationVariables>(IGNORE_FORM);

    return (input: ConnectedFormIgnoreInput) => {
        return ignoreForm({
            variables: {input: {wfFormId: input.wfFormId}},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment.
                const formFragment = proxy.readFragment({
                    id: input.wfFormId,
                    fragmentName: 'WfFormStubFragment',
                    fragment: WF_FORM_STUB_FRAGMENT,
                });

                if (formFragment) {
                    const updatedForm =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.connectedFormIgnore &&
                        mutationResults.data.connectedFormIgnore.connectedForm;

                    if (!updatedForm) return;
                    proxy.writeFragment({
                        id: input.wfFormId,
                        fragmentName: 'WfFormStubFragment',
                        fragment: WF_FORM_STUB_FRAGMENT,
                        data: updatedForm,
                    });
                }
            },
        });
    };
}
